module.exports = __webpack_public_path__ + "img/basic-options.be81a25e.svg";